import React from 'react';
import DataGrid, { Scrolling, Column } from 'devextreme-react/data-grid';
import TimeTaxSupportSystemClient from '../../../../system';
import MessageCourier from '../../../../lib/MessageCourier';
import { Spinner } from '@fluentui/react';
import { t } from 'i18next';

const columnCaptionMap: Record<string, string> = {
  EJERCICIO: t('Ejercicio'),
  PERIODO: t('Periodo'),
  COMPANIA: t('Compañía'),
  DETALLE: t('Detalle'),
  HORAS: t('Horas'),
  IMPORTE_DE_HRS_SIN_MARGEN: t('Importe de Hrs sin Margen'),
  IMPORTE_DE_HRS_CON_MARGEN: t('Importe de Hrs con Margen'),
  IMPORTE_DE_GASTOS_SIN_MARGEN: t('Importe de Gastos sin Margen'),
  IMPORTE_DE_GASTOS_CON_MARGEN: t('Importe de Gastos con Margen'),
  IMPORTE_TOTAL_SIN_MARGEN: t('Importe Total sin Margen'),
  IMPORTE_TOTAL_CON_MARGEN: t('Importe Total con Margen'),
};

const numericColumnPattern = /IMPORTE|HORAS|MONTO|TOTAL/i;

interface SettlementTablePreliquidadoReportHoursProps {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  changeBlockUI: (v: boolean) => void;
  id: string;
}

export const SettlementTablePreliquidadoReportHours = (props: SettlementTablePreliquidadoReportHoursProps) => {
  const [rows, setRows] = React.useState<Record<string, any>[]>([]);
  const [loading, setLoading] = React.useState(true);

  const columns = React.useMemo(() => (rows.length > 0 ? Object.keys(rows[0]) : []), [rows]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await props.system.getReportHoursSettlementSystem().getInformeHorasParquetData(props.id);
        console.log("vañ-data", data);
        
        setRows(data ?? []);
      } catch {
        props.courier.messageError(t('Error al cargar el detalle.'));
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  if (loading) {
    return <Spinner label={t('Cargando detalle...')} />;
  }

  if (rows.length === 0) {
    return <div>{t('No hay datos para mostrar')}</div>;
  }

  return (
    <DataGrid dataSource={rows} showBorders wordWrapEnabled height={650}>
      <Scrolling mode="virtual" />
      {columns.map((col) => (
        <Column
          key={col}
          dataField={col}
          caption={columnCaptionMap[col] ?? col}
          alignment={numericColumnPattern.test(col) ? 'right' : 'left'}
        />
      ))}
    </DataGrid>
  );
};
